<template>
  <div>
    <QS-h4-title title="合同信息" />
    <el-form
      class="contractInfoFrom"
      ref='contractInfoRef'
      :rules='contractInfoRules'
      :model='contractInfo'>
      <QS-column-box :column="2">
        <el-form-item
          prop='contractNo'
          label="业务合同编号:"
        >
          <el-input
            v-model.trim="contractInfo.contractNo"
            v-deleteEmoji="true"
            maxlength="50"
            placeholder="请输入"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop='renewalContractEndDate'
          label="合同结束日期:"
        >
          <el-date-picker
            v-model="contractInfo.renewalContractEndDate"
            :picker-options="pickerOptions"
            value-format= 'yyyy-MM-dd'
            type="date"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>

        <el-form-item
          prop='carTotalNum'
          label="租赁车辆数:"
        >
          <el-input
            v-model="contractInfo.carTotalNum"
            v-number:integer
            placeholder="请输入"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop='contractAttachment'
          label="合同附件:"
          class="alone"
        >
          <UploadCommon
            listType="text"
            :fileList="contractInfo.contractAttachment"
            :limit="20"
            :sizeType="4"
            @uploadBefore="uploadBefore"
            @uploadError="uploadComplete"
            @uploadSuccess="uploadComplete"
            commonUpload
            group="order"
            code="order_contract_attachment_file"
          />
        </el-form-item>
      </QS-column-box>
    </el-form>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    disabledTime: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      contractInfo: {
        contractNo: '',
        renewalContractEndDate: '',
        contractAttachment: [],
        carTotalNum: '',
      },
      contractInfoRules: {
        contractNo: { required: true, message: '请填写业务编号', trigger: 'blur' },
        renewalContractEndDate: { required: true, message: '请选择合同结束日期', trigger: 'change' },
        contractAttachment: [
          { validator: this.validateAttach, trigger: 'change' },
          { required: true, message: '请上传合同附件', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    'contractInfo.contractAttachment': function () {
      this.$refs.contractInfoRef.validateField('contractAttachment')
    },
  },
  computed: {
    pickerOptions() {
      const flag = this.disabledTime
      return {
        disabledDate(time) {
          const dateStart = moment(flag).startOf('day')
          return (time.getTime() <= dateStart)
        },
      }
    },
  },
  methods: {
    // 附件上传前
    uploadBefore() {
      this.$emit('uploadBefore')
    },
    // 附件上传完成
    uploadComplete() {
      this.$emit('uploadComplete')
    },
    // 附件必填校验
    validateAttach(rule, value, callback) {
      if (value && value.length === 0) {
        callback(new Error('请上传合同附件'))
        return
      }
      callback()
    },
    // eslint-disable-next-line vue/no-unused-properties
    valid() {
      let flag = false
      this.$refs.contractInfoRef.validate((valid) => {
        if (!valid) return flag
        flag = true
      })
      return flag
    },
  },
}
</script>
<style lang="scss" scoped>
.contractInfoFrom {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
</style>
